import React from "react";
import { Navigate } from "react-router-dom";
import { Box, Skeleton } from "@mui/material";
import { useAuthContext } from "../../context/AuthContext";

function Loading() {
  return (
    <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 2 }}>
      <Skeleton variant="text" width={260} height={36} />
      <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 1 }} />
    </Box>
  );
}

/**
 * Rotas exclusivas de usuário master do workspace (`usuarios.master = 1`).
 * UX only — a API revalida master a cada request.
 */
export default function RequireMaster({ children, fallback = "/dashboard/live" }) {
  const { userData, bearerToken } = useAuthContext();

  if (!bearerToken) {
    return <Navigate to="/login" replace />;
  }

  if (userData == null) {
    return <Loading />;
  }

  if (Number(userData?.master) !== 1) {
    return <Navigate to={fallback} replace />;
  }

  return children;
}
